import randomatic from 'randomatic'

export function randomAlphaNumeric(length: number): string {
  return randomatic('Aa0', length)
}
